<template>
  <div v-if="ToastOn" class="com_toast">
    <div class="com_toast_main centerposition radius4">
      <div  @click="closeFn" class="close">
        ✕
      </div>

      <div class="ToastOn_title" v-html="title"></div>
      <div class="toast_content">
        <div class="toast_main">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['title'],
    data: function () {
      return {
        ToastOn:false,
      }
    },
    created: function () {

    },
    mounted: function () {

    },
    methods: {
      closeFn:function(){
        this.ToastOn=false;
        this.$emit('closeCallback')
      },
      changeToastOn:function(flag){
        this.ToastOn=flag;
      }
    },
    components: {},
    computed: {},
  }
</script>

<style lang="scss">
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/components/com_toast/index.vue